export { ReactComponent as DefaultHeaderLogo } from './header-logo.svg';
export { ReactComponent as DefaultLeftBackgroundImage } from './left-background-image.svg';
export { ReactComponent as DefaultRightBackgroundImage } from './right-background-image.svg';
